<template>
  <b-row>
    <b-col cols="12" lg="8" order="2" order-lg="1">
      <h2 class="mb-0 title">Reglas de Aprobación</h2>

      <p class="text-muted px-2 mb-0 description">
        Determinan cuales usuarios pueden aprobar acciones específicas solicitada por otro usuario
      </p>
    </b-col>
    <b-col cols="12" lg="4" order="1" order-lg="2" class="text-right" align-self="center">
      <router-link v-if="isDev" to="/app/aprobaciones/management" class="mb-1 mb-lg-0">
        Administrar
        <font-awesome-icon :icon="['far', 'arrow-right']" fixed-width />
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  computed: {
    ...mapGetters(['isDev'])
  }
}
</script>

<style scoped>

@media (max-width: 991.98px) {
  .title {
    font-size: 1.25rem;
  }
  .description {
    font-size: 0.875rem;
  }
}
</style>
